import { call, put, takeEvery } from 'redux-saga/effects'

import apiClient from '../lib/api-client'
import Api from '../lib/Api'
import { FETCH_ORDER_REQUESTED } from '../store/order/actionTypes'
import {
  fetchOrderFailed,
  fetchOrderSucceeded
} from '../store/order/action'

const _getOrderRequested = (params) => {
  return Api.getOrder(params)
    .then((response) => response)
    .catch((e) => e.response)
}

function * fetchOrder (action) {
  try {
    const response = yield call(_getOrderRequested, action.payload)
    yield put(fetchOrderSucceeded(response.data))
  } catch (error) {
    console.log('error', error)
    yield put(fetchOrderFailed(error))
  }
}

function * OrderSaga () {
  yield takeEvery(FETCH_ORDER_REQUESTED, fetchOrder)
}

export default OrderSaga



// WEBPACK FOOTER //
// ./src/saga/order.js